import { provide, watch } from "vue";
import { usePreferredReducedMotion } from "@vueuse/core";
import { POPUP_POSITIONED } from "#ce/components/SpPopup/popup-context";

/** The bar chrome owns scrolling, regardless of which filter supplies the popup. */
export function useFinderFilterScroll(host, open, hasBarChrome) {
  const reducedMotion = usePreferredReducedMotion();
  let positioned = false;

  function resetPositionedOnOpenChange() {
    positioned = false;
  }

  watch(open, resetPositionedOnOpenChange, { flush: "sync" });

  function scrollOverflowingPanelIntoView(popup) {
    if (!hasBarChrome || !open.value || positioned) {
      return;
    }
    positioned = true;

    const row = scrollRow(host);
    if (!row) {
      return;
    }
    const rowRect = row.getBoundingClientRect();
    const panelRect = popup.getBoundingClientRect();
    const chipRect = host.getBoundingClientRect();
    const rowStyle = getComputedStyle(row);
    const usableLeft = rowRect.left + (parseFloat(rowStyle.scrollPaddingLeft) || 0);
    const usableRight = rowRect.right - (parseFloat(rowStyle.scrollPaddingRight) || 0);

    if (
      panelRect.left < rowRect.left ||
      panelRect.right > rowRect.right ||
      chipRect.left < usableLeft ||
      chipRect.right > usableRight
    ) {
      host.scrollIntoView({
        behavior: reducedMotion.value === "reduce" ? "instant" : "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  }

  provide(POPUP_POSITIONED, scrollOverflowingPanelIntoView);
}

// Follow slots as well as parents: the replacement bar's scroller is inside its shadow root.
function scrollRow(host) {
  let node = host?.assignedSlot ?? host?.parentNode;
  while (node) {
    if (node instanceof HTMLElement && /^(auto|scroll)$/.test(getComputedStyle(node).overflowX)) {
      return node;
    }
    node = node.assignedSlot ?? node.parentNode ?? node.host;
  }
  return null;
}
